var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-search-form",
      class: { "p-0": _vm.$ceres.isShopBuilder },
    },
    [
      _c(
        "div",
        { staticClass: "position-relative" },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchString,
                    expression: "searchString",
                  },
                ],
                ref: "searchInput",
                staticClass: "header-search-input search-input form-control",
                attrs: {
                  type: "search",
                  placeholder: _vm.$translate(
                    "OD3dprimaV2::Template.itemSearchSearchTerm"
                  ),
                  "aria-label": _vm.$translate(
                    "Ceres::Template.headerSearchTerm"
                  ),
                },
                domProps: { value: _vm.searchString },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchString = $event.target.value
                    },
                    function ($event) {
                      return _vm.onValueChanged($event.target.value)
                    },
                  ],
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search()
                  },
                  focus: function ($event) {
                    _vm.isSearchFocused = true
                  },
                  blur: function ($event) {
                    return _vm.onBlurSearchField($event)
                  },
                },
              }),
              _vm._v(" "),
              _vm._t("search-button", function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "search-submit header-search-btn",
                      attrs: {
                        type: "submit",
                        "aria-label": "Suche",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.headerSearch"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.search()
                        },
                      },
                    },
                    [
                      _c("icon", {
                        staticClass: "fa-fw",
                        attrs: {
                          icon: "search",
                          loading: _vm.autocompleteIsLoading,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.isSearchFocused
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasInitialInput || _vm.$ceres.isShopBuilder,
                        expression: "hasInitialInput || $ceres.isShopBuilder",
                      },
                    ],
                  },
                  [
                    _vm._t("autocomplete-suggestions", function () {
                      return [
                        _c("div", { staticClass: "autocomplete-suggestions" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "headline__24 headline__24--white bg-primary autocomplete-suggestions__title",
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.searchResultTitle"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "autocomplete-suggestions__scroll" },
                            [
                              _c("item-search-result", {
                                attrs: { type: "item" },
                              }),
                              _vm._v(" "),
                              _c("item-search-result", {
                                attrs: { type: "category" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }